/**
 * @generated SignedSource<<e5439acf8320fcb9759e36598b4b78dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OpsReservationNewPageAvailabilityQuery$variables = {
  assetTags: ReadonlyArray<any>;
  endsAt: any;
  startsAt: any;
};
export type OpsReservationNewPageAvailabilityQuery$data = {
  readonly availability: ReadonlyArray<{
    readonly asset: {
      readonly assetTag: any;
    };
    readonly message: string;
  }>;
};
export type OpsReservationNewPageAvailabilityQuery = {
  response: OpsReservationNewPageAvailabilityQuery$data;
  variables: OpsReservationNewPageAvailabilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetTags"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endsAt"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startsAt"
},
v3 = [
  {
    "kind": "Variable",
    "name": "assetTags",
    "variableName": "assetTags"
  },
  {
    "kind": "Variable",
    "name": "endsAt",
    "variableName": "endsAt"
  },
  {
    "kind": "Variable",
    "name": "startsAt",
    "variableName": "startsAt"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetTag",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationNewPageAvailabilityQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Conflict",
        "kind": "LinkedField",
        "name": "availability",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "asset",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "OpsReservationNewPageAvailabilityQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Conflict",
        "kind": "LinkedField",
        "name": "availability",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "asset",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4a1a742d25a09b59e8576c2ff1e7b441",
    "id": null,
    "metadata": {},
    "name": "OpsReservationNewPageAvailabilityQuery",
    "operationKind": "query",
    "text": "query OpsReservationNewPageAvailabilityQuery(\n  $assetTags: [AssetTag!]!\n  $startsAt: ISO8601DateTime!\n  $endsAt: ISO8601DateTime!\n) {\n  availability(assetTags: $assetTags, startsAt: $startsAt, endsAt: $endsAt) {\n    message\n    asset {\n      assetTag\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a6e01064219ad53b3388cc5bd83deb80";

export default node;
